














import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";

import ChangeCategoryForm from "@/components/forms/cinema/change-category-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, ChangeCategoryForm } })
export default class MovieCategoryForm extends Vue {
  @Prop({ type: Object, default: null }) category!: ICat | null;

  $refs!: { "change-category-form": ChangeCategoryForm };

  hide(): void {
    this.$refs["change-category-form"].onReset();
    this.$emit("hide");
  }

  updateCategory(data: Partial<ICat>, id: string): void {
    this.$emit("update", data, id);
  }
}
